import CheckboxSettingSection from "Signups/FamilyRegistration/Shared/CheckboxSettingSection";
import useFamilyRegistrationAdminPermissions from "Signups/FamilyRegistration/Shared/useFamilyRegistrationAdminPermissions";

import MembershipStatusAdminControls from "./MembershipStatusAdminControls";

export default function MembershipStatuses() {
  const {
    shouldSeparateMembershipStatusSection,
    shouldEnableMembershipStatusSection,
    shouldHideNonNetworkEnabledSettings,
  } = useFamilyRegistrationAdminPermissions();

  if (shouldHideNonNetworkEnabledSettings) return null;

  return (
    <div>
      <CheckboxSettingSection
        setting="membershipStatus"
        label="Create and Edit your Household Statuses: Ask respondents about their relationship with you"
        disabled={!shouldEnableMembershipStatusSection}
      >
        {!shouldSeparateMembershipStatusSection && (
          <MembershipStatusAdminControls />
        )}
      </CheckboxSettingSection>
    </div>
  );
}
